import axios from 'axios';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-router';
import { toast } from 'react-toastify';
import validate from 'validate.js';
import constants from 'constants';
import actions from 'actions';
import storage from 'services/storage';
import _ from 'lodash';

const {
  API_SUBSCRIPTIONS,
  SUBSCRIBE_WEBINAR_SAGA,
  UNSUBSCRIBE_WEBINAR_SAGA,
  LOAD_SUBSCRIPTIONS_SAGA,
  JOIN_WEBINAR_SAGA,
  JOIN_WEBINAR_FROM_LINK_SAGA
} = constants;

const {
  addRequestError,
  addSubscriptions,
  loadWebinarSaga,
  joinWebinarSaga
} = actions;

const apiSubscribeWebinar = (webinarId) => (
  axios.post(API_SUBSCRIPTIONS, {
    subscription: {
      webinar_id: webinarId
    }
  })
)

const apiUnsubscribeWebinar = (id) => (
  axios.delete(`${API_SUBSCRIPTIONS}/${id}`)
)

const apiLoadSubscriptions = () => (
  axios.get(API_SUBSCRIPTIONS)
)

const apiJoinWebinar = (webinar_id) => (
  axios.put(`${API_SUBSCRIPTIONS}/0`, {
    webinar_id
  })
)

function* subscribeWebinar({ webinar }) {
  try {
    yield call(apiSubscribeWebinar, webinar.id)
    yield put(loadWebinarSaga(webinar.id))
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* unsubscribeWebinar({ id, webinarId }) {
  try {
    yield call(apiUnsubscribeWebinar, id)
    yield put(loadWebinarSaga(webinarId))
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadSubscriptions() {
  try {
    const response = yield call(apiLoadSubscriptions);
    const subscriptions = response.data.subscription;
    yield put(addSubscriptions(subscriptions));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* joinWebinar({ webinarId, redirect = false, handleErrors = false }) {
  try {
    storage.removeJoinWebinarId(null);
    const response = yield call(apiJoinWebinar, webinarId)
    yield put(loadWebinarSaga(webinarId))

    if (redirect) {
      window.location = response.data.subscription.join_url
    } else {
      if (window.webinarTab && response.data && response.data.subscription && response.data.subscription.join_url)
        window.webinarTab.location.href = response.data.subscription.join_url
    }

  } catch (e) {
    if (handleErrors) {
      toast.warn('Webinar not found')
      yield put(push('/'))
    }
    yield put(addRequestError(e.response));
  }
}

function* joinWebinarFromLinkSaga({ webinarId }) {
  try {
    const isLogged = yield select(store => !_.isEmpty(store.users.user));
    if (isLogged) {
      yield put(joinWebinarSaga(webinarId, true, true));
    } else {
      storage.setJoinWebinarId(webinarId);
      toast.warn('To proceed, you must be logged in');
      yield put(push('/users/sign_in'))
    }
  } catch (e) {
    console.log(e);
  }
}

// SAGAS
function* __subscribeWebinarSaga() {
  yield takeLatest(SUBSCRIBE_WEBINAR_SAGA, subscribeWebinar)
}

function* __unsubscribeWebinarSaga() {
  yield takeLatest(UNSUBSCRIBE_WEBINAR_SAGA, unsubscribeWebinar)
}

function* __unsubscribeWebinarSaga() {
  yield takeLatest(UNSUBSCRIBE_WEBINAR_SAGA, unsubscribeWebinar)
}

function* __loadSubscriptionsSaga() {
  yield takeLatest(LOAD_SUBSCRIPTIONS_SAGA, loadSubscriptions)
}

function* __joinWebinarSaga() {
  yield takeLatest(JOIN_WEBINAR_SAGA, joinWebinar)
}

function* __joinWebinarFromLinkSaga() {
  yield takeLatest(JOIN_WEBINAR_FROM_LINK_SAGA, joinWebinarFromLinkSaga)
}

export {
  __subscribeWebinarSaga,
  __unsubscribeWebinarSaga,
  __loadSubscriptionsSaga,
  __joinWebinarSaga,
  __joinWebinarFromLinkSaga
};



/** WEBPACK FOOTER **
 ** ./src/sagas/subscriptions.js
 **/